var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 16.874V12.749C11.0625 12.5667 10.9901 12.3918 10.8611 12.2629C10.7322 12.134 10.5573 12.0615 10.375 12.0615H7.625C7.44266 12.0615 7.2678 12.134 7.13886 12.2629C7.00993 12.3918 6.9375 12.5667 6.9375 12.749V16.874C6.9375 17.0564 6.86507 17.2312 6.73614 17.3602C6.6072 17.4891 6.43234 17.5615 6.25 17.5615H2.125C1.94266 17.5615 1.7678 17.4891 1.63886 17.3602C1.50993 17.2312 1.4375 17.0564 1.4375 16.874V8.9247C1.43908 8.82956 1.45968 8.73569 1.49809 8.64864C1.53651 8.56158 1.59195 8.48309 1.66117 8.41779L8.53617 2.16979C8.66288 2.05397 8.82833 1.98975 9 1.98975C9.17167 1.98975 9.33712 2.05397 9.46383 2.16979L16.3388 8.41779C16.4081 8.48305 16.4636 8.56154 16.502 8.6486C16.5404 8.73567 16.561 8.82955 16.5625 8.9247V16.875C16.5625 17.0573 16.4901 17.2322 16.3611 17.3611C16.2322 17.49 16.0573 17.5625 15.875 17.5625H11.75C11.5677 17.5625 11.3928 17.49 11.2639 17.3611C11.1349 17.2322 11.0625 17.0564 11.0625 16.874Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fd5d61cf147a3976101a1c85d3a898a5.svg";
export { ForwardRef as ReactComponent };